module.exports = __webpack_public_path__ + "img/formBg.f79a070.png";